import { Navigate, RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { RoutePaths } from '@utils/route.utils.ts';
import HotelWifiFeatureGuard from '@core/components/hotel-wifi-feature-guard/hotel-wifi-feature-guard.tsx';

const AppBuilderComponent = lazy(() => import('./app-builder.tsx'));
const TvBrandingComponent = lazy(
  () => import('./pages/tv-branding/tv-branding.tsx')
);
const TabletBrandingComponent = lazy(
  () => import('./pages/tablet-branding/tablet-branding.tsx')
);
const MobileBrandingComponent = lazy(
  () => import('./pages/mobile-branding/mobile-branding.tsx')
);
const CaptivePortalBrandingComponent = lazy(
  () => import('./pages/captive-portal/captive-portal-branding.tsx')
);

export const appBuilderRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <AppBuilderComponent />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={RoutePaths.Core.AppBuilder.TvBranding.absolutePath}
            replace
          />
        )
      },
      {
        path: RoutePaths.Core.AppBuilder.TvBranding.path,
        element: (
          <Suspense>
            <TvBrandingComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.AppBuilder.TabletBranding.path,
        element: (
          <Suspense>
            <TabletBrandingComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.AppBuilder.MobileBranding.path,
        element: (
          <Suspense>
            <MobileBrandingComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.AppBuilder.CaptivePortal.path,
        element: (
          <Suspense>
            <HotelWifiFeatureGuard
              redirectTo={RoutePaths.Core.AppBuilder.TvBranding.absolutePath}
            >
              <CaptivePortalBrandingComponent />
            </HotelWifiFeatureGuard>
          </Suspense>
        )
      }
    ]
  }
];
